<script lang="ts">

	import QrCode from "./QrCode.svelte";
	import * as UrlManager from './UrlManager';	

	export let hash: string;

	function copy(): void {
		const copyText = document.querySelector("#url");
		copyText.select();
		document.execCommand("copy");
	}

</script>


<section>
  <div>
    <button class="contrast" on:click={UrlManager.generate} type="submit">Generate a new piece of art</button>

    <div id='qrcode'>
      <QrCode urlForQrCode={UrlManager.getUrlWithHash(hash)} />
      <span>Scan QR code to get URL and share</span>
    </div>	

    <div class="grid">
      <input
        type="text"
        id="url"
        name="url"
        value={UrlManager.getUrlWithHash(hash)}
        readonly
      />
      
      <button class="secondary" on:click={copy}>Copy URL and share</button>

    </div>

  </div>
</section>


<style>
	#url {
		font-style: italic;
	}
	#qrcode {
		margin-bottom: 10px;
	}
</style>
